import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ROUTES } from '../../app/utils/CONSTANTS';
import axios from 'axios';

// Define initial state
const initialState = {
  data: null,
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null as string | null,
};

// Async thunk to fetch EmpOracleHierarchyDetails
export const fetchEmpOracleHierarchyDetails = createAsyncThunk(
  'empOracleHierarchyDetails/fetchEmpOracleHierarchyDetails',
  async (managerOracleId: string, { rejectWithValue }) => {
    try {
      if (!managerOracleId) {
        return rejectWithValue('Manager Oracle ID is required');
      }
       const response: { success: boolean; data: any } = await axios({
        method: "get", 
         url: `${ROUTES.getEmpOracleHierarchyDetails}?mOracleId=${encodeURIComponent(managerOracleId)}`,
         withCredentials : true
      });
      // Validate response structure
      if (!response || typeof response !== 'object') {
        return rejectWithValue('Invalid API response format');
      }
      
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch employee hierarchy details');
    }
  }
);

const empOracleHierarchyDetailsSlice = createSlice({
  name: 'empOracleHierarchyDetails',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchEmpOracleHierarchyDetails.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchEmpOracleHierarchyDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload as any;
      })
      .addCase(fetchEmpOracleHierarchyDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      });
  },
});

export default empOracleHierarchyDetailsSlice.reducer;
